// extracted by mini-css-extract-plugin
export default {"userPhoto":"ThirdPage_userPhoto__8dptx"};